import React, { useState, useEffect } from 'react';
import styles from '../EditDiv/EditDiv.module.css';
import buttonStyles from '../YesNoButtonsCSS/YesNoButtons.module.css';
import TickBox from '../TickBox/TickBox';
import CommentBox from '../CommentBox/CommentBox';

function UpdateAddressPopUp({
  isVisible,
  onClose,
  onSubmit,
  data,
}) {
  const [address, setAddress] = useState('');
  const [reason, setReason] = useState('');
  const [updateFilenames, setUpdateFilenames] = useState(false);

  useEffect(() => {
    if (data && Array.isArray(data.DataEdit)) {
      const get = (name) => (data.DataEdit.find(d => d.dataName === name) || {}).data;
      setAddress(get('Address') || '');
      setReason(get('Reason') || '');
      setUpdateFilenames(false);
    }
  }, [data]);

  if (!isVisible) return null;

  const handleSubmit = () => {
    const payload = {
      ...(address !== undefined ? { 'Address': address } : {}),
      ...(reason !== undefined ? { 'Reason': reason } : {}),
      'Files': updateFilenames,
    };
    if (typeof onSubmit === 'function') onSubmit('Update Address', payload);
    onClose();
  };

  return (
    <div className={styles.backGround} style={{ position: 'fixed' }} onClick={onClose}>
      <div
        className={styles.form}
        style={{ width: '418px' }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={styles.momentTitle}>MOMENT</div>
        <div className={styles.sectionTitle}>Update Address</div>

        <ul className={styles.List}>
          <li className={styles.dataRow}>
            <div className={styles.dataTitle}>Address:</div>
            <div className={styles.commentHolder}>
              <CommentBox initialData={address} onValueChange={setAddress} />
            </div>
          </li>
          <li className={styles.dataRow}>
            <div className={styles.dataTitle}>Reason:</div>
            <div className={styles.largeCommentHolder}>
              <CommentBox initialData={reason} onValueChange={setReason} />
            </div>
          </li>
          <li className={styles.dataRow}>
            <div className={`${styles.dataTitle} ${styles.wrappedLabel}`}>Update Files on SP:</div>
            <div className={styles.commentHolder}>
              <div
                className={styles.checkBoxHolder}
                title={
                  'Include associated files in the update — filenames will be updated and files re-associated with the new address.'
                }
              >
                <TickBox
                  type={updateFilenames}
                  tickClick={() => setUpdateFilenames(v => !v)}
                  coloureis={'#4EA5D9'}
                  aria-label={'Update filenames and re-associate files to new address'}
                />
              </div>
              <div style={{ fontSize: '12px', color: '#666', marginTop: '6px' }}>
                Checking this will update filenames and re-associate any files attached to the old address so they reflect the new address.
              </div>
            </div>
          </li>
        </ul>

        <div className={styles.updateAndCancel}>
          <div className={styles.updateButton} onClick={handleSubmit}>
            <div className={buttonStyles.YesButtonComponentStyling}>UPDATE</div>
          </div>
          <div className={styles.cancelButton} onClick={onClose}>
            <div className={buttonStyles.NoButtonComponentStyling}>CANCEL</div>
          </div>
        </div>

        <img className={styles.blueLogo} src={require('../../assets/BlueLogo.png')} alt="BlueLogo" />
      </div>
    </div>
  );
}

export default UpdateAddressPopUp;


